var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCriticalThinking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 108.22,
    cy: 59.52,
    r: 14.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.44,138H76.87s.44-32.88,0-43.45,9.25-9.84,9.25-9.84h42.49s9.69-.73,9.25,9.84,0,43.45,0,43.45H127.29"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "88.47 105.12 88.47 203.62 101.1 203.62 101.1 162.22 113.63 162.22 113.63 203.62 126.26 203.62 126.26 105.12"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 107.88,
    y1: 31.44,
    x2: 107.88,
    y2: 13.96
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "97.91 19.88 107.82 13.11 117.84 19.57"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 80.29,
    y1: 59.43,
    x2: 62.81,
    y2: 59.43
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "68.73 69.39 61.96 59.49 68.42 49.47"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 136.67,
    y1: 59.43,
    x2: 154.15,
    y2: 59.43
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "148.23 49.47 155 59.37 148.53 69.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81,59.52a27.19,27.19,0,0,1,54.37,0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCriticalThinking);
export default __webpack_public_path__ + "static/media/CRITICAL_THINKING.79c85de8d292e7accffdd11bd6fc547b.svg";
export { ForwardRef as ReactComponent };